import './App.css';
import {useState,useEffect,useRef} from 'react';  
function Qoute()
{
    const [data,setdata]=useState({"_id":"76zdyW69GU3f","content":"In rivers, the water that you touch is the last of what has passed and the first of that which comes; so with present time.","author":"Leonardo da Vinci","tags":["famous-quotes"],"authorSlug":"leonardo-da-vinci","length":123,"dateAdded":"2020-02-07","dateModified":"2020-02-07"});
    const [bool,setbool]=useState(0);
    const div=useRef();
    const Text=useRef();    
    const Author=useRef();
    const Button=useRef();
    useEffect(()=>{
        fetch('https://api.quotable.io/random?Maxlength=50?tags=famous-qoutes').then((response)=>response.json()).then((Data)=>{
               setdata(Data);   
        });  
    },[bool]);  
    const Change=()=>{
        fetch('https://api.quotable.io/random?Maxlength=50?tags=famous-qoutes').then((response)=>response.json()).then((Data)=>{
            setdata(Data);    
     });
        const r=Math.floor(Math.random()*180);  
        const g=Math.floor(Math.random()*180);   
        const b=Math.floor(Math.random()*180);  
        const Color="rgb("+r+","+g+","+b+")";   
        div.current.style.backgroundColor=Color;  
        Text.current.style.color=Color;
        Author.current.style.color=Color;
        Button.current.style.backgroundColor=Color;  
    }
    const {content,author}=data;
    return (
        <div className="qoute" ref={div}>   
             <div className="qoute-body" >  
                  <div className="qoute-text" ref={Text}>   
                  <i class="fa-solid fa-quote-left" ></i>{content}</div>  
                  <div className="qoute-author" ref={Author}>      
                       - {author}        
                  </div>
                  <button className="btn" onClick={Change} ref={Button}>New Qoute</button>    
             </div>   
        </div>
    );
}
export default Qoute;  